import api from './api';

const channelConnectionsService = {
  async getAll() {
    const response = await api.get('/channel-connections');
    return response.data;
  },
  async getSocialConfig() {
    const response = await api.get('/social/oauth/config');
    return response.data;
  },
  async exchangeSocialLogin(data) {
    const response = await api.post('/social/oauth/exchange', data);
    return response.data;
  },
  async setSocialActive(id, isActive) {
    const response = await api.patch(`/social/connections/${id}`, { is_active: isActive });
    return response.data;
  },
  async resubscribeSocial(id) {
    const response = await api.post(`/social/connections/${id}/resubscribe`);
    return response.data;
  },
  async disconnectSocial(id) {
    const response = await api.delete(`/social/connections/${id}`);
    return response.data;
  },
};

export default channelConnectionsService;
